import { defineAsyncComponent } from 'vue'
import type { PowerUpModalData } from '/@/pages/Vizi/Edit/elements/PowerUps/types'
import { stellaModal } from '/@/stella/StellaModal'

export function usePowerUpsModal() {
  function openPowerUpModal(
    data: PowerUpModalData,
    type?: 'modal' | 'overlay-panel',
  ) {
    stellaModal.open({
      content: defineAsyncComponent(
        () =>
          import('/@/pages/Vizi/Edit/elements/modals/PowerUpModalContent.vue'),
      ),
      data,
      type: type || 'overlay-panel',
    })
  }

  return {
    openPowerUpModal,
  }
}
